"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCbr = void 0;
const version = "v4";
const getCountryMappings_1 = require("./getCountryMappings");
function getCbr(country) {
    try {
        let countryCode2 = country;
        if (country.length !== 2) {
            countryCode2 = (0, getCountryMappings_1.getCountryMapping)(country).countryCode2;
        }
        countryCode2 = countryCode2.toUpperCase();
        if (countryCode2 === "GB") {
            countryCode2 = "UK";
        }
        const cbr = require("../country-business-rules/" +
            version +
            "/self-service/" +
            countryCode2 +
            ".json");
        return JSON.parse(JSON.stringify(cbr));
    }
    catch (e) {
        throw "Could not locate business rules for country: " + country;
    }
}
exports.getCbr = getCbr;
